// src/components/cooler/inventory/components/ItemGrid.tsx

import React from 'react';
import { Grid } from '@mui/material';
import type { InventoryItem } from '../types/inventoryTypes';
import { ItemCard } from './ItemCard';

interface ItemGridProps {
  items: InventoryItem[];
  onItemClick: (item: InventoryItem) => void;
  onMaintenanceClick: (item: InventoryItem) => void;
  onDelete?: (id: string) => void;
  onCategoryFilter?: (category: string) => void;
  onLocationFilter?: (location: string) => void;
  onShelfFilter?: (location: string, shelf: string) => void;
}

export const ItemGrid: React.FC<ItemGridProps> = ({
  items,
  onItemClick,
  onMaintenanceClick,
  onDelete,
  onCategoryFilter,
  onLocationFilter,
  onShelfFilter,
}) => {
  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
          <ItemCard
            item={item}
            onClick={() => onItemClick(item)}
            onMaintenanceClick={(e) => {
              e.stopPropagation();
              onMaintenanceClick(item);
            }}
            onDelete={onDelete}
            onCategoryFilter={onCategoryFilter}
            onLocationFilter={onLocationFilter}
            onShelfFilter={onShelfFilter}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ItemGrid;